import { useContext } from 'react';
import { LandscapeContext } from '@/contexts/landscape';

export function useLandscapeOverlay() {
  const context = useContext(LandscapeContext);
  if (!context) {
    throw new Error('useLandscapeOverlay must be used within a LandscapeProvider');
  }
  return context;
}
